<template>
	<div>
<!--		<breadcrumb />-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-optionItem">
				<div class="h-optionItemin">
					<ul>
						<!-- <li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon1">
									<div class="h-tableCell" @click="addweek" style="cursor: pointer;">
										<p>制定计划</p>
										<span>新建计划</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon2">
									<div class="h-tableCell" @click="demandPage" style="cursor: pointer;">
										<p>需求分析</p>
										<span>新建需求</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon3">
									<div class="h-tableCell" @click="managePage" style="cursor: pointer;">
										<p>项目经理</p>
										<span>转化项目</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon4">
									<div class="h-tableCell" @click="newProjectPage" style="cursor: pointer;">
										<p>在线下单</p>
										<span>在线下单</span>
									</div>
								</div>
							</a>
						</li> -->
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon5">
									<div class="h-tableCell" @click="orderMore" style="cursor: pointer;">
										<p>订单跟踪</p>
										<span>订单跟踪</span>
									</div>
								</div>
							</a>
						</li>
						<!-- <li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon6">
									<div class="h-tableCell" @click="contractPage" style="cursor: pointer;">
										<p>合同管理</p>
										<span>转化合同</span>
									</div>
								</div>
							</a>
						</li> -->
						<!-- <li>
							<a>
								<div class="h-oItemIntro h-disTable">
									<div class="h-tableCell">
										<p class="h-txtCenter">+ 增加快捷入口</p>
									</div>
								</div>
							</a>
						</li> -->
					</ul>
				</div>
			</div>
            <!-- <div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div style="display:flex;justify-content:space-between;align-items:center;padding:20px 0;">
							<div style="color:#0072f6;font-size:16px;">模块展示</div>
							<div style="display:flex;align-items:center;">
							</div>
						</div>
					</div>
				</div>
			</div> -->
            <div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>金额报表</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="h-funnelChart">
								<div class="h-funnelChartIn" style="display:flex;width:100%;margin:0;height:300px;">
									<div class="h-pieChart" id="h_lineChart1" style="width: 25%; height: 100%;"></div>
									<div class="h-pieChart" id="h_lineChart2" style="width: 25%; height: 100%;"></div>
									<div class="h-pieChart" id="h_lineChart3" style="width: 25%; height: 100%;"></div>
									<div class="h-pieChart" id="h_lineChart4" style="width: 25%; height: 100%;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<!-----------------------代办-->
				<!--代办-->
				<!--代办-->
				<tasklist divheight="7.4rem" :pagesize="10"/>
				<!--代办-->
				<!--代办-->
				<!--代办-->
                <div class="h-rowIn" style="width: 61.5%;">
					<div class="h-rowBox" style="height:7.4rem">
						<div class="h-rowTitle" style="border:0">
							<div class="h-disTable">
								<div class="h-tableCell">
									<div class="selecBox" style="margin-top:0.23rem;border-bottom: 1px solid #e1e1e1;">
										<div class="button" :class="{'active':paidex==index}" v-for="(item,index) in paiminglist" :key="index" @click="tab2(index)">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon" style="height:7rem">
							<div class="blankimg" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 80%;">
							</div>
                            <!-- <div style="height:7rem" v-show="paidex == 0">
							    <div class="h-pieChart" id="h_pieChart1" style="width: 100%;height:100%;" ref="h_pieChart1"></div>
                            </div>
                            <div style="height:7rem" v-show="paidex == 1">
                                ssssssssss
                            </div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<myOrderList :firstPageFlag="1"/>
			</div>

		</div>

	</div>
</template>

<script>
import '../../../../node_modules/echarts/map/js/china.js'
import tasklist from '@/components/task/mytask.vue'
import ss from "../../../api/SystemService";
import myOrderList from '../../dingdmain/dingd-list.vue'
import big from 'big.js'
import creditService from "../../../api/loud/credit/creditService";

    export default {
    	components:{
            tasklist,
			myOrderList
		},
        data() {
            return {
                paiminglist:['预测匹配','销售匹配'],
				paidex:0,
				msgAgent:false,
                value: '',
                formInline:{
                    quyu:'',
                    qudao:'',
                    mubiao:'',
                    dalei:'',
                    type:''
                },
            }
        },
        methods: {
			addweek(){
				//创建周计划，查询当前用户下周计划状态
				var planstatus=0;
				ss.UserCare.weekPlanStatus().then(rd => {
					if(rd.obj&&rd.obj.length>0){
						planstatus=rd.obj[0].planStatus;
						if(planstatus==1){
							this.$msg.msge("周计划已提交，请等待审核");
						}else if(planstatus==2){
							this.$msg.msge("周计划已生成，请勿重复操作");
							// this.$message({
							// 	message: '周计划已生成，请勿重复操作',
							// 	type: 'warning'
							// });
						}else{
							this.$router.push("/weekplan");
						}
					}else{
						this.$router.push("/weekplan");
					}
				})
			},
			demandPage(){
				this.$router.push({path:"/xuqiu/Lmanagement"});
			},
			managePage(){
				this.$router.push();
			},
			newProjectPage(){
				this.$router.push({path:"/xiangmu/newProject", query:{type:"new"}});
			},
			contractPage(){
				this.$router.push({path:"/contract-list"});
			},
			orderMore(){
				this.$router.push({path:"/dingd/dingdmainlist"});
			},
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            },
			handleSizeChange(v){
				console.log(v)
			},
			handleCurrentChange(v){
				console.log(v)
            },

            lineChart1(){
                let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
                let option = {
                    title : {
                        text: '销售目标',
                        bottom:'25%',
                        left:'center',
                        textVerticalAlign:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom:"5%",
                        data: []
                    },
                    series : [
                        {
                            name: '销售目标',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '35%'],
                            data:[],
                            // label: {
                            //     normal: {
                            //         show: false,
                            //         position: 'center'
                            //     }
                            // },
                            // labelLine: {
                            //     normal: {
                            //         show: false
                            //     }
                            // },
                            hoverOffset:10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color:function(params) {
                                //自定义颜色
                                var colorList = [
                                    '#afe6fd', '#5ba9fe'
                                ];
                                return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart1.setOption(option);
            },
            lineChart2(){
                let lineChart2 = this.$echarts.init(document.getElementById('h_lineChart2'));
                let option = {
                    title : {
                        text: '余额信贷',
                        bottom:'25%',
                        left:'center',
                        textVerticalAlign:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom:"5%",
                        data: []
                    },
                    series : [
                        {
                            name: '余额信贷',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '35%'],
                            data:[],
                            // label: {
                            //     normal: {
                            //         show: false,
                            //         position: 'center'
                            //     }
                            // },
                            // labelLine: {
                            //     normal: {
                            //         show: false
                            //     }
                            // },
                            hoverOffset:10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color:function(params) {
                                //自定义颜色
                                var colorList = [
                                    '#afe6fd', '#5ba9fe'
                                ];
                                return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart2.setOption(option);
            },
            lineChart3(){
                let lineChart3 = this.$echarts.init(document.getElementById('h_lineChart3'));
                let option = {
                    title : {
                        text: '返利图表',
                        bottom:'25%',
                        left:'center',
                        textVerticalAlign:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom:"5%",
                        data: []
                    },
                    series : [
                        {
                            name: '返利图表',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '35%'],
                            data:[],
                            // label: {
                            //     normal: {
                            //         show: false,
                            //         position: 'center'
                            //     }
                            // },
                            // labelLine: {
                            //     normal: {
                            //         show: false
                            //     }
                            // },
                            hoverOffset:10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color:function(params) {
                                //自定义颜色
                                var colorList = [
                                    '#afe6fd', '#5ba9fe'
                                ];
                                return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart3.setOption(option);
            },
            lineChart4(){
                let lineChart4 = this.$echarts.init(document.getElementById('h_lineChart4'));
                let option = {
                    title : {
                        text: '订单图表',
                        bottom:'25%',
                        left:'center',
                        textVerticalAlign:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        bottom:"5%",
                        data: []
                    },
                    series : [
                        {
                            name: '订单图表',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '35%'],
                            data:[],
                            // label: {
                            //     normal: {
                            //         show: false,
                            //         position: 'center'
                            //     }
                            // },
                            // labelLine: {
                            //     normal: {
                            //         show: false
                            //     }
                            // },
                            hoverOffset:10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color:function(params) {
                                //自定义颜色
                                var colorList = [
                                    '#afe6fd', '#5ba9fe',"#74b6ff","#1b86ff"
                                ];
                                return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart4.setOption(option);
            },
            piechart(){
				ss.firstPageService.selectList().then(rd=>{
					var today = new Date();
					var year = today.getFullYear();
					var m = today.getMonth()+1;
					var times = [];
					for (var i = m-1; i >= 0; i--) {
						var n = m - i;
						if (n < 10) {
							times.push(year+'-0'+n);
						} else {
							times.push(year+'-'+n);
						}
					}
					var result = [];
					for (var i = 0; i < times.length; i++) {
						rd.forEach((item, index) => {
							if (item.month == times[i]) {
								var num = new big(item.pronum).times(100);
								result.push(parseInt(num));
							} else {
								result.push(0);
							}
						})
					}
					let piechart = this.$echarts.init(this.$refs.h_pieChart1);
					let option = {
						xAxis: {
							type: 'category',
							boundaryGap: false,
							data: times
						},
						tooltip: {
							trigger: 'axis'
						},
						yAxis: {
							type: 'value',
							axisLabel:{
								formatter:'{value} %'
							}
						},
						series: [{
							data: result,
							type: 'line',
							// radius : '0%',
							// center: ['0%', '0%'],
							barWidth: '10%',
							areaStyle: {
								normal: {
									color: '#f3faff' //改变区域颜色
								},
							},
							itemStyle:{
								normal:{
									color: "#0098f6"
								}
							}
						}]
					};
					piechart.setOption(option);
				});
            },
            tab2(index){
                // this.paidex = index;
                this.$set(this,"paidex",index);
                if(this.paidex==0){
                    this.piechart()
                }
			},
          getAgentFileEffectiveDate(){
            let data = {
              userCode:this._user.usercode
            }
            console.log("rd",this._user)
            ss.firstPageService.getFileEffectiveDate(data).then(rd=>{
              console.log("rd",rd)
              var flag = rd.obj;
              var msg = null;
              if(flag.XKZ && flag.YYZZ){
                msg = "企业营业执照,许可证";
              }else if(flag.XKZ){
                msg = "许可证";
              }else if(flag.YYZZ){
                msg = "企业营业执照";
              }
              if(null != msg){
                let val = localStorage.getItem("showNotifyAgent");
                val = JSON.parse(val);
                console.log(val, "缓存main");
                //如果缓存有效并且未过期
                if(val.showNotify||val.showNotify=='true'){
                    this.$alert("尊敬的用户,您的"+msg+"即将到期,请尽快更新证件，并更新有效截止日期，证件到期后，系统将自动冻结账户!", '系统通知', {
                      confirmButtonText: '确定',
                      type:'warning',
                    });
                    //将缓存置为无效
                    val.showNotify = false;
                    //localStorage 设置的值不能为对象,转为json字符串
                    localStorage.setItem("showNotifyAgent", JSON.stringify(val));
                }
              }
            })

			  ss.firstPageService.getHavepolicy2017(data).then(rd=>{
				  console.log("rd",rd)
				  var flag = rd.obj;
				  if(null != flag && flag == 0){
					  let val = localStorage.getItem("showHavepolicy2017");
					  val = JSON.parse(val);
					  console.log(val, "缓存main");
					  //如果缓存有效并且未过期
					  if(val.showNotify||val.showNotify=='true'){
						  this.$alert("尊敬的用户,请及时勾选2017版分类目录,如未勾选将在一个月后限制下单!", '系统通知', {
							  confirmButtonText: '确定',
							  type:'warning',
						  });
						  //将缓存置为无效
						  val.showNotify = false;
						  //localStorage 设置的值不能为对象,转为json字符串
						  localStorage.setItem("showHavepolicy2017", JSON.stringify(val));
					  }
				  }
			  })

          },
          showTixing(){
            let txFlag = JSON.parse(sessionStorage.getItem("showSalesTixing"));
            console.log("showSalesTixing",txFlag);
            if(null == txFlag){
              ss.fanli.showAgentSalesTixing().then(rd => {
                if(rd.f){
                  this.$alert(rd.msg.message, '返利实际与目标差额提示', {
                    confirmButtonText: '确定',
                    type:'warning',
                    dangerouslyUseHTMLString:true,
                    customClass:'message_box_alert',
                    callback: action => {
                      ss.fanli.remindedAgentSalesTixing(rd.msg.id);
                      this.$message({
                        type: 'info',
                        message: '您可以点击右上角消息中心再次查看实际与目标的差额'
                      });
                    }
                  });
                }
              });
              //设为不提醒
              txFlag = 'false';
              sessionStorage.setItem("showSalesTixing",txFlag);
            }
          },

            //it服务台通知 没人只通知一次
            showITService(){
                // 提示通知
                let val = localStorage.getItem("showITService1");
                val = JSON.parse(val);
                console.log("123123",val);
                //如果缓存有效并且未过期
                if(val==null||val=='true'){
                    //这里再对数据库进行校验 防止缓存被清除
                    this.$alert("   为提升系统运维服务，量化系统运维质量，OMS运维已启用IT服务台，大家有问题请通过IT服务台提交，运维人员优先解决IT服务台提交的问题，谢谢！</br>IT服务器台路径：系统右下角，点击“IT服务台”图标", 'OMS系统运维启用IT服务台通知', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        type:'warning',
                    });
                    //将缓存置为无效
                    val = 'false';
                    console.log("JSON.stringify(val)",JSON.stringify(val))
                    localStorage.setItem("showITService1", JSON.stringify(val));
                }
            },

            //系统维护通知
            showMaintain(){
                // 提示通知
                let val = localStorage.getItem("showNotifyMain");
                val = JSON.parse(val);
                console.log(val, "缓存main");
                console.log(val, "缓存login");

                //如果是经销商
                if(this._user.usertype == '1' || this.msgAgent){
					//如果缓存有效并且未过期
					if(val.showNotify||val.showNotify=='true'){

						const aLiUrl = require("../../../assets/images/agengtmsg.png")

						if (Date.now()/1000/60/60 - val.time/1000/60/60 < val.expire) {
							this.$alert("<strong><img src="+ aLiUrl + " width=1000px height=300px>", '系统通知', {
								confirmButtonText: '确定',
								dangerouslyUseHTMLString: true,
								customClass: 'custom-alert', // 添加自定义类
							});

							//将缓存置为无效
							val.showNotify = false;
							//localStorage 设置的值不能为对象,转为json字符串
							localStorage.setItem("showNotifyMain", JSON.stringify(val));
						}
					}
				}
            },


			//经销商对账提醒
			showDuiZhangService(){
				creditService.selectContrastSapById().then(rd => {
					console.log(rd)
					if(rd.msg == 1){
						this.$alert("尊敬的用户,您当月信贷对账还未提交,请及时到信贷管理资金详情下提交!", 'OMS信贷对账提醒', {
							confirmButtonText: '确定',
							dangerouslyUseHTMLString: true,
							type:'warning',
						});
						return;
						/*// 提示通知
						let val = localStorage.getItem("showDuiZhangService");
						val = JSON.parse(val);
						console.log("123123",val);
						//如果缓存有效并且未过期
						if(val==null||val=='true'){
							//这里再对数据库进行校验 防止缓存被清除
							//将缓存置为无效
							val = 'false';
							console.log("JSON.stringify(val)",JSON.stringify(val))
							localStorage.setItem("showDuiZhangService", JSON.stringify(val));
						}*/
					}
				})
			},
          showITServiceMaindealer(){
            let obj = {
              showNotify: true,  //是否有效
              time: Date.now(),    //当前时间
              expire: 12          //有效时间 12小时
            };
            // 提示通知
            let suerId = localStorage.getItem("userId");
            let val = localStorage.getItem("showNotifyMaindealer" + suerId);
            val = JSON.parse(val);
            console.log(val, "缓存showNotifyMaindealer" + suerId);
            //如果缓存有效并且未过期
            if(val!=null && (val.showNotify ||val.showNotify=='true')){
              if (Date.now()/1000/60/60 - val.time/1000/60/60 > val.expire) {
                this.$alert('本月系统签收时间截止1.25日中午12：00，生物医疗本部、康盛、海盛杰经销商请提前与销售联系提前做好规划。', 'OMS系统通知', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                });

                //将缓存置为无效
                obj.showNotify = true;
                localStorage.setItem("showNotifyMaindealer"  + suerId, JSON.stringify(obj));
              }
            }else{
              this.$alert('本月系统签收时间截止1.25日中午12：00，生物医疗本部、康盛、海盛杰经销商请提前与销售联系提前做好规划。', 'OMS系统通知', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
              });
              //将缓存置为无效
              obj.showNotify = true;

              localStorage.setItem("showNotifyMaindealer"  + suerId, JSON.stringify(obj));
            }

          },

        },
		mounted(){
     // this.showITServiceMaindealer();
        //IT服务台通知
        this.showITService();
        this.showDuiZhangService();
        this.showMaintain();
      //返利在签经销商实际目标差额提醒弹框
      this.showTixing();
            // this.lineChart1();
            this.lineChart2();
            this.lineChart3();
            this.lineChart4();
            this.piechart();
            this.getAgentFileEffectiveDate();
			this.msgAgent = this.$store.getters.hasRole('swyl_daqujl,swyl_quyujl,SHICHANG_PINGTAI,swyl_caiwujl');
			//销售目标
			ss.firstPageService.getAgentSaleInfo().then(rd=>{
				var target = rd.target;
				var totalOrder = rd.totalOrder;
				var undone = target>totalOrder?target - totalOrder:0;
				let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
				let name1 = '未达成：￥'+undone;
				let name2 = '已达成：￥'+totalOrder;
				lineChart1.setOption({
					legend:{data:[name1,name2]},
					series:[{
						data:[{value:undone,name:name1,selected:true},{value:totalOrder,name:name2}]
					}]
				})
			});
			//余额信贷
			ss.firstPageService.getAgentCreditInfo().then(rd=>{
				var maxquota = rd.maxquota;
				var quota = rd.quota;
				var credit = maxquota - quota;
				let lineChart2 = this.$echarts.init(document.getElementById('h_lineChart2'));
				let name1 = '未使用：￥'+quota;
				let name2 = '已使用：￥'+credit;
				lineChart2.setOption({
					legend:{data:[name1,name2]},
					series:[{
						data:[{value:quota,name:name1,selected:true},{value:credit,name:name2}]
					}]
				})
			});
			//返利信息
			ss.firstPageService.getAgentRebateInfo().then(rd=>{
				var cashed = rd.cashed;
				var tocash = rd.tocash;
				let lineChart3 = this.$echarts.init(document.getElementById('h_lineChart3'));
				let name1 = '未兑：￥'+tocash;
				let name2 = '已兑：￥'+cashed;
				lineChart3.setOption({
					legend:{data:[name1,name2]},
					series:[{
						data:[{value:tocash,name:name1,selected:true},{value:cashed,name:name2}]
					}]
				})
			});
			//订单图表
			ss.firstPageService.getAgentOrderInfo().then(rd=>{
				var waitcheck = rd.waitcheck;
				var waitfahuo = rd.waitfahuo;
				var complete = rd.complete;
				let lineChart4 = this.$echarts.init(document.getElementById('h_lineChart4'));
				let name1 = '审批中：'+waitcheck+'个';
				let name2 = '待发货：'+waitfahuo+'个';
				let name3 = '已完成：'+complete+'个';
				lineChart4.setOption({
					legend:{data:[name1,name2,name3]},
					series:[{
						data:[{value:waitcheck,name:name1,selected:true},{value:waitfahuo,name:name2},{value:complete,name:name3}]
					}]
				})
			})
        },
    }
</script>
<style scoped>
.selecBox{
	display: flex;
}
.selecBox .button{
	width: 85px;
	height: 0.46rem;
	color: #767676;
	text-align: center;
	line-height: 0.42rem;
	border:1px solid #dddfe4;
	background: #fff;
	cursor: pointer;
	font-size: 0.16rem;
    border-bottom: 0
}
.selecBox .button.active{
	background: #2686e7;
	border:1px solid #2686e7;
	color: #fff;
}
.textBox{
	margin-top: 20px;
	margin-left: 20px;
}
.textBox span{
	color: #bec3c4;
	font-size: 16px;
	margin-left: 30px;
}
.textBox span:first-child{
	margin: 0;
}
.paimingBox{
	margin-top: 50px;
	display: flex;
	flex-direction: column;
	margin-left: 10px;
}
.paimingBox .title{
	font-size: 14px;
	color: #c6ced1;
	margin-bottom: 10px;
}
.paimingBox .borderBox{
	width: 160px;
	height: 12px;
	border-radius: 6px;
	background: #def2ff;
	position: relative;
}
.paimingBox .borderBox .borders{
	position: absolute;
	width: 20%;
	height: 12px;
	border-radius: 6px;
	background: #5aabff;
}
</style>
<style>
.h-row .dingdan .h-mrt30{
	margin: 10px;
}
.h-tableCell .el-input__inner {
	width: 1.3rem;
    color: #DCDFE6;
    border-radius: 0;
    height: 0.32rem;
    line-height: 0.28rem;
    border: 1px solid #DCDFE6;
    font-size: 0.16rem;
    padding-right: 0.3rem;
    padding-left: 0.15rem;
}
.h-tableCell .el-input__icon{
	line-height: 0;
}
.fenyes .h-pagiLabel{
	display: none;
}
.fenyes .el-pagination .el-pagination__sizes{
	display: none;
}
.message_box_alert {
  width: 750px !important;
}
.custom-alert {
	width: 1050px !important;
	height: 450px !important;
}
</style>
